<template>
  <layout-main-inner title="批次详情">
    <template slot="append">
      <span style="color:#888"
            v-if="userPermission.SUPERVISE || userPermission.OPERATE">({{batchInfo.vendorName}})</span>
      <el-tag type="danger"
              v-if="batchInfo.status === 9">紧急召回({{batchInfo.statusDesc}})</el-tag>
      <el-tag type="success"
              v-if="batchInfo.status === 3">检验通过</el-tag>
    </template>
    <product-info :loading="loading"
                  :product="product" />

    <batch-form-dz ref="form"
                   :isDetail="true"
                   :loading="loading"
                   :batch="batchInfo"
                   :productId="product.productId"
                   :tradeType="product.tradeType"
                   :vendorId="+$route.query.vendorId"
                   v-if="product.tagType === 1" />

    <batch-form-pm ref="form"
                   :isDetail="true"
                   :loading="loading"
                   :batch="batchInfo"
                   :productId="product.productId"
                   :tradeType="product.tradeType"
                   :tagType="product.tagType"
                   :vendorId="+$route.query.vendorId"
                   v-if="product.tagType !== 1 && batchInfo.tagModel === 1 && product.codingType === 1 " />

    <batch-form-pm-ck ref="form"
                      :isDetail="true"
                      :loading="loading"
                      :batch="batchInfo"
                      :productId="product.productId"
                      :tradeType="product.tradeType"
                      :tagType="product.tagType"
                      :vendorId="+$route.query.vendorId"
                      v-if="product.tagType !== 1 && batchInfo.tagModel === 1 && product.codingType === 2 " />

    <batch-form-tm ref="form"
                   :isDetail="true"
                   :loading="loading"
                   :batch="batchInfo"
                   :tradeType="product.tradeType"
                   :tag="tagInfo"
                   :productId="product.productId"
                   :tagType="product.tagType"
                   :vendorId="+$route.query.vendorId"
                   v-if="product.tagType !== 1 && batchInfo.tagModel === 2 && product.codingType === 1  " />

    <batch-form-tm-ck ref="form"
                      :isDetail="true"
                      :loading="loading"
                      :batch="batchInfo"
                      :productId="product.productId"
                      :tradeType="product.tradeType"
                      :tagType="product.tagType"
                      :vendorId="+$route.query.vendorId"
                      v-if="product.tagType !== 1 && batchInfo.tagModel === 2 && product.codingType === 2 " />
    <template slot="footer">
      <back-button ref="back" />
      <el-button type="primary"
                 @click="edit"
                 v-if="(batchInfo.status !== 9 && userPermission.ENT && batchInfo.status !== 3)"
                 :loading="loading">编辑</el-button>
                 <!-- && (batchInfo.outGoodsCount === null ||  batchInfo.outGoodsCount === 0) -->
      <el-button type="primary"
                 @click="edit"
                 v-if="userPermission.OPERATE && (batchInfo.status === 9 || batchInfo.status === 3)"
                 :loading="loading">编辑</el-button>
    </template>
  </layout-main-inner>
</template>
<script>
import ProductInfo from './busi/product-info.vue'
import batchFormDz from './busi/batch-form-dz.vue'
import batchFormPm from './busi/batch-form-pm.vue'
import batchFormTm from './busi/batch-form-tm.vue'
import batchFormPmCk from './busi/batch-form-pm-ck.vue'
import batchFormTmCk from './busi/batch-form-tm-ck.vue'
import TemplateFormat from '@/utils/templateFormat'
import { mapState } from 'vuex'
export default {
  name: 'batch-detail',
  components: { ProductInfo, batchFormDz, batchFormPm, batchFormTm, batchFormPmCk, batchFormTmCk },
  props: {},
  data () {
    return {
      loading: false,
      batchInfo: {},
      product: {},
      tagInfo: {}
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  methods: {
    getBatch (config, cb) {
      this.loading = true
      this.$store.dispatch('batch/getbatch', {
        payload: config,
        success: (res) => {
          this.loading = false
          res.data.baseFields = TemplateFormat.editTemplateFormat(res.data.baseFields)
          res.data.extraFields = TemplateFormat.editTemplateFormat(res.data.extraFields || [])
          this.batchInfo = res.data
          if (res.data.tagModel === 2 && res.data.codingType === 1) {
            this.tagInfo = {
              tagCount: res.data.tagCount,
              beginTagNo: res.data.beginTagNo,
              endTagNo: res.data.endTagNo
            }
          }
          cb && cb(res.data.productId)
        },
        fail: () => {
          this.loading = false
          this.batchInfo = {}
        }
      })
    },
    getproduct (config) {
      this.loading = true
      this.$store.dispatch('product/getproduct', {
        payload: config,
        success: (res) => {
          this.loading = false
          this.product = res.data
        },
        fail: () => {
          this.loading = false
          this.product = {}
        }
      })
    },
    edit () {
      this.$router.push(`/batch-update?vendorId=${this.$route.query.vendorId}&batchId=${this.$route.query.batchId}&productId=${this.$route.query.productId}`)
    }
  },
  beforeRouteUpdate (to, from, next) {
    console.log(to, from, next)
    if (to.fullPath !== from.fullPath) {
      next()
      this.getBatch({
        vendorId: this.$route.query.vendorId,
        batchId: this.$route.query.batchId
      })
      this.getproduct({
        vendorId: this.$route.query.vendorId,
        productId: this.$route.query.productId
      })
    }
  },
  mounted () {
    this.getBatch({
      vendorId: this.$route.query.vendorId,
      batchId: this.$route.query.batchId
    })
    this.getproduct({
      vendorId: this.$route.query.vendorId,
      productId: this.$route.query.productId
    })
  }
}
</script>
